import { Badge } from "@/components/ui/baseUi/badge"
import { cn } from "@/modules/lib/utils"
import { BoxOfferDropInIcon } from "@images/svgIcons/boxOffer/dropInIcon"
import { BoxOfferFlagIcon } from "@images/svgIcons/boxOffer/flagIcon"
import { word } from "@modules/core/utils/i18n"

export type ParticipantBadgeType = "trial" | "dropIn"

type ParticipantBadgeProps = {
  type: ParticipantBadgeType
} & React.ComponentProps<"div">

export function ParticipantBadge({ type, className, ...props }: ParticipantBadgeProps) {
  const getBadgeConfig = () => {
    switch (type) {
      case "trial":
        return {
          label: word("participant.badge.trial"),
          icon: <BoxOfferFlagIcon color="currentColor" className="text-textDefault-caption" width={16} height={16} />,
        }
      case "dropIn":
        return {
          label: word("participant.badge.dropIn"),
          icon: <BoxOfferDropInIcon color="currentColor" className="text-textDefault-caption" width={16} height={16} />,
        }
    }
  }

  const config = getBadgeConfig()

  return (
    <Badge variant="primarySubtle" size="lg" className={cn(className)} {...props}>
      {config.icon}
      {config.label}
    </Badge>
  )
}
